import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { isEqual, pick } from 'lodash-es'
import { Scrollbars } from 'react-custom-scrollbars'

import InputRange from '../../Common/InputRange/InputRange'
import InputRangeWithConvert from '../../Common/InputRange/InputRangeWithConvert'

// TODO: refactor to '../../Common/Buttons/Button' (use index file)
import Button from '../../Common/Buttons/Button/Button'
import InputNumeric from '../../Common/InputNumeric/InputNumeric'

import {
  addNewSetting,
  updateLastSetting,
  updateSettingsIds,
  applyAdjust,
  removeLastSetting,
} from '../../../store/actions/settings.actions'
import { getLastAdjustSetting } from '../../../helpers/util'
import { sendMetric } from '../../../helpers/metric'

import { mapControls } from '../../../constants/controls'
import { ReactComponent as ResetIcon } from '../../../assets/images/icons/i-reset.svg'
import IconButton from '../../Common/Buttons/IconButton/IconButton'

import './AdjustControl.scss'
import PseudoSelect from '../../Common/PseudoSelect/PseudoSelect'
import DesktopModal from '../../Common/DesktopModal/DesktopModal'

const defaultValues = {
  brightness: 0,
  contrast: 0,
  saturation: 0,
}

class AdjustControl extends PureComponent {
  static propTypes = {
    imageSrc: PropTypes.string.isRequired,
    settingsList: PropTypes.array.isRequired,
    currentSettingId: PropTypes.number.isRequired,
    addNewSetting: PropTypes.func.isRequired,
    updateLastSetting: PropTypes.func.isRequired,
    updateSettingsIds: PropTypes.func.isRequired,
    brightnessApplied: PropTypes.bool.isRequired,
    contrastApplied: PropTypes.bool.isRequired,
    saturationApplied: PropTypes.bool.isRequired,
    applyAdjust: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    dispatchRemoveLastSetting: PropTypes.func.isRequired,
  }

  state = {
    isModalOpen: false
  }

  onModalClose = () => {
    this.setState({
      isModalOpen: false
    })
  }

  onPseudoSelectClick = () => {
    this.setState({
      isModalOpen: true
    })
  }

  onChange = (value, name) => {
    const { imageSrc, settingsList, currentSettingId, updateLastSetting } = this.props

    if (!imageSrc) return

    const lastSetting = getLastAdjustSetting(settingsList, currentSettingId)

    if (lastSetting && lastSetting.id === currentSettingId && lastSetting.name === 'adjust') {
      updateLastSetting({
        ...lastSetting,
        values: { ...lastSetting.values, [name]: value },
      })
    }
  }

  onClick = (value, name) => {
    const {
      imageSrc,
      settingsList,
      currentSettingId,
      addNewSetting,
      updateSettingsIds,
      brightnessApplied,
      contrastApplied,
      saturationApplied,
      updateLastSetting,
    } = this.props
    if (!imageSrc) return

    const lastSetting = getLastAdjustSetting(settingsList, currentSettingId)

    const values = lastSetting ? lastSetting.values : defaultValues

    if (name === 'brightness') this.sendAdjustMetric(brightnessApplied, name)
    if (name === 'contrast') this.sendAdjustMetric(contrastApplied, name)
    if (name === 'saturation') this.sendAdjustMetric(saturationApplied, name)

    if (!lastSetting || lastSetting.isCommitted) {
      updateSettingsIds(currentSettingId + 1)
      addNewSetting({
        name: 'adjust',
        id: currentSettingId + 1,
        isCommitted: false,
        values: { ...values, [name]: value },
      })
    } else {
      updateLastSetting({
        ...lastSetting,
        values: { ...lastSetting.values, [name]: value },
      })
    }
  }

  onChangeInput = (value, name) => {
    const { imageSrc } = this.props
    if (!imageSrc || value === null) return

    const { adjust } = mapControls

    let correctValue = Number(value)

    const currentAdjust = adjust.find((adjuster) => adjuster.name === name)


    if (correctValue < currentAdjust.min) {
      correctValue = currentAdjust.min
    } else if (correctValue > currentAdjust.max) {
      correctValue = currentAdjust.max
    }

    this.onClick(correctValue, currentAdjust.name)
  }

  sendAdjustMetric = (apply, name) => {
    const { applyAdjust } = this.props

    const item = mapControls.adjust.filter((item) => item.name === name)[0]
    if (!apply) {
      sendMetric({
        event: 'ADJUST_APPLIED',
        gtm: {
          eventCategory: 'Interactions',
          eventAction: 'click',
          eventLabel: 'ADJUST_APPLIED'
        },
        amplitude: {
          SETTING_NAME: item.name
        }
      })
      applyAdjust(name)
    }
  }

  valideKeys = (e) => {
    const { value } = e.target
    if (e.key == '-' && value.includes('-') ) {
      e.preventDefault()
    } else if (
      e.keyCode == 46 ||
      e.keyCode == 8 ||
      e.keyCode == 9 ||
      e.keyCode == 16 ||
      e.keyCode == 27 ||
      (e.keyCode == 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39) ||
      (e.keyCode == 189 && e.shiftKey !== true) || 
      e.keyCode == 109 || e.keyCode == 40
    ) {
      return
    } else {
      if (!isFinite(Number(e.key)) || e.key === ' ') {
        e.preventDefault()
      }
    }
  }

  onReset = () => {
    const {
      settingsList,
      currentSettingId,
      addNewSetting,
      updateSettingsIds,
      dispatchRemoveLastSetting
    } = this.props
    const lastSetting = getLastAdjustSetting(settingsList, currentSettingId)

    if (!lastSetting.isCommitted && settingsList.length === 1) {
      dispatchRemoveLastSetting()
    } else {
      // replace a setting if it is not committed
      const nextSettingId = !lastSetting.isCommitted ? currentSettingId : currentSettingId + 1

      updateSettingsIds(nextSettingId)
      addNewSetting({
        name: 'adjust',
        id: nextSettingId,
        isCommitted: true,
        values: { ...defaultValues },
      })
    }
    sendMetric({
      event: 'ADJUST_RESETED',
      amplitude: {}
    })
  }

  onApply = () => {
    const {
      settingsList,
      currentSettingId,
      updateLastSetting
    } = this.props
    const lastSetting = getLastAdjustSetting(settingsList, currentSettingId)

    updateLastSetting({
      ...lastSetting,
      isCommitted: true,
    })
  }

  render() {
    const { imageSrc, settingsList, currentSettingId, t } = this.props
    const { isModalOpen } = this.state
    const [brightness, contrast, saturation] = mapControls.adjust
    const lastSetting = getLastAdjustSetting(settingsList, currentSettingId)
    const adjustValues = lastSetting ? pick(lastSetting.values, Object.keys(defaultValues)) : defaultValues

    return (
      <Scrollbars
        style={{ height: '100%' }}
        renderThumbVertical={(props) => <div {...props} className="thumb-vertical" />}
      >
        <div className="adjust">
          <div className="adjust__title">{t('titles.adjust')}</div>
          <div className="adjust__control">
            <div className="adjust__control-wrapper">
              <div className={`adjust__name ${!imageSrc ? 'adjust__name_disabled' : ''}`}>
                {t(`controls.${brightness.name}`)}
              </div>
              <InputNumeric
                className="input-text input-text_small"
                value={lastSetting ? lastSetting.values.brightness : 0}
                min={brightness.min}
                max={brightness.max}
                onKeyDown={this.valideKeys}
                maxLength={3}
                onChange={(value) => this.onChangeInput(value, brightness.name)}
              />
            </div>
            <InputRange
              min={brightness.min}
              max={brightness.max}
              roundBy={1}
              value={lastSetting ? lastSetting.values.brightness : 0}
              onChange={(value) => this.onChange(value, brightness.name)}
              onClick={(value) => this.onClick(value, brightness.name)}
              disabled={!imageSrc}
            />
          </div>
          <div className="adjust__control">
            <div className="adjust__control-wrapper">
              <div className={`adjust__name ${!imageSrc ? 'adjust__name_disabled' : ''}`}>
                {t(`controls.${contrast.name}`)}
              </div>
              <InputNumeric
                className="input-text input-text_small"
                value={lastSetting ? lastSetting.values.contrast : 0}
                min={contrast.min}
                max={contrast.max}
                onKeyDown={this.valideKeys}
                onChange={(value) => this.onChangeInput(value, contrast.name)}
              />
            </div>
            <InputRangeWithConvert
              visualMin={-100}
              visualMax={100}
              min={contrast.min}
              max={contrast.max}
              roundBy={1}
              value={lastSetting ? lastSetting.values.contrast : 0}
              onChange={(value) => this.onChange(value, contrast.name)}
              onClick={(value) => this.onClick(value, contrast.name)}
              disabled={!imageSrc}
            />
          </div>
          <div className="adjust__control">
            <div className="adjust__control-wrapper">
              <div className={`adjust__name ${!imageSrc ? 'adjust__name_disabled' : ''}`}>
                {t(`controls.${saturation.name}`)}
              </div>
              <InputNumeric
                className="input-text input-text_small"
                value={lastSetting ? lastSetting.values.saturation : 0}
                min={saturation.min}
                max={saturation.max}
                onKeyDown={this.valideKeys}
                onChange={(value) => this.onChangeInput(value, saturation.name)}
              />
            </div>
            <InputRange
              min={saturation.min}
              max={saturation.max}
              roundBy={1}
              value={lastSetting ? lastSetting.values.saturation : 0}
              onChange={(value) => this.onChange(value, saturation.name)}
              onClick={(value) => this.onClick(value, saturation.name)}
              disabled={!imageSrc}
            />
          </div>
          <div className="adjust__control">
            <IconButton
              caption={t('buttons.reset')}
              captionHorizontal
              disabled={isEqual(adjustValues, defaultValues) && (!lastSetting || lastSetting.isCommitted)}
              onClick={this.onReset}
            >
              <ResetIcon />
            </IconButton>
          </div>
          <div className="adjust__buttons">
            <Button
              block
              disabled={!imageSrc || !lastSetting || lastSetting.isCommitted}
              onClick={this.onApply}
            >
              {t('buttons.apply')}
            </Button>
          </div>
          <div className="adjust__extra-control-first">
            <PseudoSelect onClick={this.onPseudoSelectClick} id="gtm-peo-ANB-1559-click-ddlist-selection-tools">
              {t('pseudo-select.selection-tools')}
            </PseudoSelect>
          </div>
          <div className="adjust__extra-control">
            <PseudoSelect onClick={this.onPseudoSelectClick} id="gtm-peo-ANB-1559-click-ddlist-ai-adjust">
              {t('pseudo-select.ai-adjust')}
            </PseudoSelect>
          </div>
          <div className="adjust__extra-control">
            <PseudoSelect onClick={this.onPseudoSelectClick} id="gtm-peo-ANB-1559-click-ddlist-light">
              {t('pseudo-select.light')}
            </PseudoSelect>
          </div>
          <div className="adjust__extra-control">
            <PseudoSelect onClick={this.onPseudoSelectClick} id="gtm-peo-ANB-1559-click-ddlist-color">
              {t('pseudo-select.color')}
            </PseudoSelect>
          </div>
          <div className="adjust__extra-control">
            <PseudoSelect onClick={this.onPseudoSelectClick} id="gtm-peo-ANB-1559-click-ddlist-detail">
              {t('pseudo-select.detail')}
            </PseudoSelect>
          </div>
          <DesktopModal isOpen={isModalOpen} onCLose={this.onModalClose} />
        </div>
      </Scrollbars>
    )
  }
}

const mapStateToProps = ({
  imageStore: { imageSrc },
  settingsStore: { settingsList, currentSettingId, brightnessApplied, contrastApplied, saturationApplied },
}) => ({
  imageSrc,
  settingsList,
  currentSettingId,
  brightnessApplied,
  contrastApplied,
  saturationApplied,
})

const mapDispatchToState = (dispatch) => ({
  addNewSetting: (setting) => dispatch(addNewSetting(setting)),
  updateLastSetting: (setting) => dispatch(updateLastSetting(setting)),
  updateSettingsIds: (id) => dispatch(updateSettingsIds(id)),
  applyAdjust: (name) => dispatch(applyAdjust(name)),
  dispatchRemoveLastSetting: (id) => dispatch(removeLastSetting(id)),
})

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToState
  )(AdjustControl)
)
